import { cx } from '@emotion/css';
import { Col, Row } from 'antd';
import { MTooltip, MTypography } from 'src/lib';
import { AlignItems, Color, Display } from 'src/styles';

import { OfferDetails } from '../../../../models/offers.models';

import { getFirstColumnDetails, getSecondColumnDetails } from './constants';
import * as Styles from './OfferDetailsTab.styles';

export interface OfferDetailsTabProps {
  offering: OfferDetails;
}

export const OfferDetailsTab = ({ offering }: OfferDetailsTabProps) => {
  const detailsTabDataFirstColumn = getFirstColumnDetails(offering);

  const detailsTabDataSecondColumn = getSecondColumnDetails(offering);

  return (
    <Row className={Styles.container}>
      <Col className={Styles.tabContainer}>
        {detailsTabDataFirstColumn.map(offerDetails => {
          return (
            !offerDetails.hidden && (
              <div key={offerDetails.label} className={Styles.detailTabs}>
                <MTypography variant='subtitle1' color={Color.Brand5} className={Styles.detailsLabel}>
                  {offerDetails.label}
                </MTypography>
                <div className={Styles.detailsValue}>{offerDetails.value}</div>
              </div>
            )
          );
        })}
      </Col>

      <Col className={Styles.tabDataContainer}>
        {detailsTabDataSecondColumn.map(offerDetails => {
          return (
            !offerDetails.hidden && (
              <div key={`${offerDetails.label}_key`} className={Styles.detailTabs}>
                <MTypography variant='subtitle1' color={Color.Brand5} className={Styles.detailsLabel}>
                  <span className={cx(Display.flex, AlignItems.center)}>
                    {offerDetails.label}
                    {offerDetails.description && <MTooltip>{offerDetails.description}</MTooltip>}
                  </span>
                </MTypography>
                <div className={Styles.detailsValue}>{offerDetails.value}</div>
              </div>
            )
          );
        })}
      </Col>
    </Row>
  );
};
